export default __webpack_public_path__ + "static/media/delete-warning.842eab19.svg";